var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconEyeGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "13px",
    viewBox: "0 0 20 13",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_eye") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Login-01-A",
    transform: "translate(-919.000000, -529.000000)",
    fill: "#95C11F",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(600.000000, 240.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(40.000000, 249.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(0.000000, 22.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M289.0044,18.5998418 C292.672376,18.5481567 296.329515,21.1124054 298.534469,23.5382715 C299.160863,24.2370252 299.16194,25.2949543 298.53697,25.9949819 C296.355358,28.395839 292.750738,30.9375798 289.126944,30.9375798 L289.126944,30.9375798 L288.870186,30.9375798 C285.258896,30.9375798 281.653443,28.395839 279.474331,25.9958155 C278.848532,25.2961511 278.848532,24.2379359 279.474331,23.5382715 C281.679285,21.1132391 285.336424,18.547323 289.0044,18.5998418 Z M289.0044,20.9340084 C286.886553,20.9340084 285.169698,22.6508631 285.169698,24.7687108 C285.169698,26.8865584 286.886553,28.6034131 289.0044,28.6034131 C291.122248,28.6034131 292.839103,26.8865584 292.839103,24.7687108 C292.839103,22.6508631 291.122248,20.9340084 289.0044,20.9340084 Z M289.0044,23.1014489 C289.925204,23.1014489 290.671662,23.8479075 290.671662,24.7687108 C290.671662,25.6895141 289.925204,26.4359727 289.0044,26.4359727 C288.083597,26.4359727 287.337138,25.6895141 287.337138,24.7687108 C287.337138,23.8479075 288.083597,23.1014489 289.0044,23.1014489 Z",
    id: "icon_eye"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEyeGreen);
export default __webpack_public_path__ + "static/media/icon_eye_green.196b1bfc6ad7c28d0c4dcce4f1ad6f24.svg";
export { ForwardRef as ReactComponent };